import React from "react";
import classes from "./FooterLanguageOptions.module.css";
import useLanguageHook from "../../../../Hooks/useLanguageHook";

function FooterLanguageOptions() {
  const { currentLanguage, updateLanguage } = useLanguageHook();
  return (
    <select
      aria-label="Language"
      id="footer-language-options"
      className={`${classes["footer-language-options"]}`}
      value={currentLanguage}
      onChange={(e) => {
        updateLanguage(e.target.value);
        let ciciEventAction = '';
        if (e.target.value === 'en') {
          ciciEventAction = 'cici_en_lang_click';
        }
        if (e.target.value === 'es') {
          ciciEventAction = 'cici_es_lang_click';
        }
        window.dataLayer.push({
          event: 'cici_event',
          action: ciciEventAction
        })
      }}
    >
      <option value="en" >English</option>
      <option value="es" >Español</option>
    </select>
  );
}

export default FooterLanguageOptions;
